module.exports = __webpack_public_path__ + "static/media/loader.b37b883b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/loader.svg
// module id = 1302
// module chunks = 0